var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5652 16.2003L17.6132 13.3143C17.0302 12.7463 16.0882 12.7513 15.5132 13.3263L14.3152 14.5253C12.0802 14.6263 9.37022 11.8963 9.45622 9.66126L10.6722 8.44426C11.3362 7.78126 11.1772 6.82626 10.6652 6.32326L7.72322 3.42726C7.13922 2.85426 6.19622 2.85826 5.62022 3.43526C4.09922 4.95626 2.44822 6.20626 3.17822 9.28726C3.58422 11.0033 4.44422 13.3663 7.51822 16.4403C10.6142 19.5363 12.9832 20.3983 14.7012 20.8043C15.1622 20.9123 15.6082 20.9663 16.0382 20.9663C18.4792 20.9663 19.6362 19.2653 20.5772 18.3243C21.1632 17.7383 21.1632 16.7853 20.5652 16.2003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFilled);
export default __webpack_public_path__ + "static/media/contact-filled.6fc5c2320f9404631ef9ebbc7f34dec8.svg";
export { ForwardRef as ReactComponent };